export const DEFAULT_RESERVATION_CONFIG = {
  reservationDurationMinutes: 30,
  depositAmountMinor: 0,
  cancellationWindowMinutes: 10,
  noShowGracePeriodMinutes: 5,
};

export const timeDeltaToMinutes = (timedelta: string): number => {
  if (timedelta.startsWith("PT")) {
    const match = timedelta.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
    if (match) {
      const hours = parseInt(match[1] || "0", 10);
      const minutes = parseInt(match[2] || "0", 10);
      return hours * 60 + minutes;
    }
  }
  const parts = timedelta.split(":");
  if (parts.length === 3) {
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    return hours * 60 + minutes;
  }
  return 0;
};

export const minutesToTimeDelta = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours > 0) {
    return `PT${hours}H${mins}M`;
  }
  return `PT${mins}M`;
};

export const formatCurrency = (
  amountMinor: number,
  currency: string
): string => {
  const amountMajor = amountMinor / 100;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
  }).format(amountMajor);
};
